import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

import countries, { Alpha3Code } from 'i18n-iso-countries';

import { Rule } from '../../../utilities/schemas/rules';
import languages from '../../../constants/languages';

export interface IPCountryAllowlistParams {
  updateFreq: number;
  countries: Alpha3Code[];
}

const IPCountryAllowlist = ({ rule }: {
  rule: Rule;
}) => (
  <Grid
    alignItems="baseline"
    size={{
      xs: 12,
      sm: 6,
      lg: 4,
    }}
  >
    <Box display="flex" flexDirection="row" gap={1} alignItems="baseline">
      <Typography sx={{ fontWeight: 'bold', fontSize: 10 }}>
        Allowlist
      </Typography>
      <Typography fontSize={10}>
        {(rule.ruleParameters as IPCountryAllowlistParams)
          .countries.map((country) => countries.getName(country, languages.EN))
          .join(', ')}
      </Typography>
    </Box>
  </Grid>
);

export default IPCountryAllowlist;
